export default "__VITE_ASSET__DaF2s23F__"